import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  description: {
    marginBottom: theme.spacing(2),
    color: theme.palette.text.secondary,
  },
  actions: {
    padding: theme.spacing(2, 3),
  },
}));

export default useStyles;
